import PropTypes from 'prop-types';
import React from 'react';

// The visible quote validity is capped at 10s (figma node 13092:81286). This
// ring depletes over that window: the dark arc retracts as time runs out. The
// 1s-linear transition makes it glide smoothly between the per-second ticks
// instead of jumping in steps.
const DEFAULT_TOTAL_SECONDS = 10;
const RADIUS = 12;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const QuoteCountdownRing = ({ remainingSeconds, totalSeconds, className }) => {
  const fraction = totalSeconds > 0 ? Math.max(0, Math.min(1, remainingSeconds / totalSeconds)) : 0;
  const dashOffset = CIRCUMFERENCE * (1 - fraction);

  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      role="img"
      aria-hidden>
      <circle cx="14" cy="14" r={RADIUS} stroke="#E5E5E5" strokeWidth="2" />
      <circle
        data-testid="quote-countdown-progress"
        cx="14"
        cy="14"
        r={RADIUS}
        stroke="#150F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={dashOffset}
        transform="rotate(-90 14 14)"
        style={{ transition: 'stroke-dashoffset 1s linear' }}
      />
    </svg>
  );
};

QuoteCountdownRing.propTypes = {
  remainingSeconds: PropTypes.number,
  totalSeconds: PropTypes.number,
  className: PropTypes.string
};

QuoteCountdownRing.defaultProps = {
  remainingSeconds: 0,
  totalSeconds: DEFAULT_TOTAL_SECONDS,
  className: ''
};

export { QuoteCountdownRing };
